export default {
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  device: 'desktop'
}
